import { Action } from "@ngrx/store";
import { DataStateChangeEvent } from "@progress/kendo-angular-grid";
import { Preset, PresetColumn } from "app/core/interfaces/preset";

export const MODIFY_PRESET_COLUMNS = "MODIFY_PRESET_COLUMNS";
export const MODIFY_PRESET_STATE = "MODIFY_PRESET_STATE";
export const RESET_PRESET_MODIFIED_FLAG = "RESET_PRESET_MODIFIED_FLAG";
export const SAVE_PRESET = "SAVE_PRESET";
export const SELECT_PRESET = "SELECT_PRESET";
export const SET_PRESET_COLUMNS = "SET_PRESET_COLUMNS";
export const SET_DOCUMENTS_TOTAL_COUNT = "SET_DOCUMENTS_TOTAL_COUNT";
export const SET_OVERDUE_WORKFLOWS_COUNT = "SET_OVERDUE_WORKFLOWS_COUNT";
export const SET_UNDER_REVIEW_WORKFLOWS_COUNT =
    "SET_UNDER_REVIEW_WORKFLOWS_COUNT";
export const SET_WORKFLOWS_TOTAL_COUNT = "SET_WORKFLOWS_TOTAL_COUNT";

export class ModifyPresetColumnsAction implements Action {
    readonly type = MODIFY_PRESET_COLUMNS;

    constructor(public payload: PresetColumn[]) {}
}

export class ModifyPresetStateAction implements Action {
    readonly type = MODIFY_PRESET_STATE;

    constructor(public payload: DataStateChangeEvent) {}
}

export class ResetPresetModifiedAction implements Action {
    readonly type = RESET_PRESET_MODIFIED_FLAG;
}

export class SavePresetAction implements Action {
    readonly type = SAVE_PRESET;

    constructor(public payload: Preset) {}
}

export class SelectPresetAction implements Action {
    readonly type = SELECT_PRESET;

    constructor(public payload: Preset) {}
}

export class SetDocumentsTotalCountAction implements Action {
    readonly type = SET_DOCUMENTS_TOTAL_COUNT;

    constructor(public payload: number) {}
}

export class SetPresetColumnsAction implements Action {
    readonly type = SET_PRESET_COLUMNS;

    constructor(public payload: PresetColumn[]) {}
}

export class SetOverdueWorkflowsCountAction implements Action {
    readonly type = SET_OVERDUE_WORKFLOWS_COUNT;

    constructor(public payload: number) {}
}

export class SetUnderReviewWorkflowsCountAction implements Action {
    readonly type = SET_UNDER_REVIEW_WORKFLOWS_COUNT;

    constructor(public payload: number) {}
}

export class SetWorkflowsTotalCountAction implements Action {
    readonly type = SET_WORKFLOWS_TOTAL_COUNT;

    constructor(public payload: number) {}
}

export type TrackerActions =
    | ModifyPresetColumnsAction
    | ModifyPresetStateAction
    | ResetPresetModifiedAction
    | SavePresetAction
    | SelectPresetAction
    | SetDocumentsTotalCountAction
    | SetOverdueWorkflowsCountAction
    | SetPresetColumnsAction
    | SetUnderReviewWorkflowsCountAction
    | SetWorkflowsTotalCountAction;
